import { isWhiteKey, midiToNoteName } from '../../stores/synthModel.js'

export function buildPianoKeyGeometry(minMidi, maxMidi, whiteKeyWidth = 34) {
  const blackKeyWidth = Math.max(18, Math.round(whiteKeyWidth * 0.62))
  const keys = []
  let whiteIndex = 0

  for (let midi = minMidi; midi <= maxMidi; midi++) {
    const isWhite = isWhiteKey(midi)
    if (isWhite) {
      keys.push({ midi, noteName: midiToNoteName(midi), isWhite, x: whiteIndex * whiteKeyWidth, width: whiteKeyWidth })
      whiteIndex += 1
    } else {
      keys.push({ midi, noteName: midiToNoteName(midi), isWhite, x: whiteIndex * whiteKeyWidth - blackKeyWidth / 2, width: blackKeyWidth })
    }
  }

  return { keys, width: whiteIndex * whiteKeyWidth, whiteKeyWidth, blackKeyWidth }
}
